import { render, staticRenderFns } from "./Newpayrun.vue?vue&type=template&id=987b711e"
import script from "./Newpayrun.vue?vue&type=script&lang=js"
export * from "./Newpayrun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports